import { render, staticRenderFns } from "./ItemDataWoo.vue?vue&type=template&id=59585c2e&scoped=true&"
import script from "./ItemDataWoo.vue?vue&type=script&lang=js&"
export * from "./ItemDataWoo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59585c2e",
  null
  
)

export default component.exports